import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
})
export class IconComponent {
  displayIcon: boolean = false;
  iconName: string = '';

  @Input() colorClass: string = 'color-secondary-500';
  @Input() height: string | null = '24px';
  @Input() width: string | null = '24px';
  @Input() strokeWidth: string = '2px';

  @Input() isLoading: boolean = false;

  @Input() set name(name: string) {
    if (name) {
      this.iconName = name;
      this.displayIcon = true;
    }
  }
}
